import React from 'react'

export default function Message() {
    return (
        <div>
            <p>Add an Amount and the Term to Repay</p>
        </div>
    )
}
